import { Col, Image, Row } from 'react-bootstrap'
import Link from 'next/link'

function MoreRelatedContent() {
    return (
        <div className="py-5">
            <p>More Nutrition Related Content</p>
            <Row>
                {
                    [
                        { url:"nutrition", image:"/images/test/Picture19.jpg", section:"healthy-recipe"},
                        { url:"hello", image:"/images/test/Picture22.jpg", section:"healthy-body"},
                        { url:"adios", image:"/images/test/Picture21.jpg", section:"healthy-beauty"},
                        { url:"beauty", image:"/images/test/more1.jpg", section:"healthy-kids"},
                        { url:"adios", image:"/images/test/more2.jpg", section:"healthy-beauty"},
                        { url:"beauty", image:"/images/test/more3.jpg", section:"healthy-kids"}
                    ].map((data,idx) => (
                        <Col md={4} key={idx} className="mb-2">
                            <Link href="/[category]/[page]" as={`/${data.section}/${data.url}`} replace>
                                <a><Image src={data.image} className="img-fluid" /></a>
                            </Link>
                        </Col>
                    ))
                }
            </Row>
        </div>
    )
}

export default MoreRelatedContent
